package com.kinoshazam.uiKit.components.cells.cellIcon

import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.painter.Painter
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp


data class CellIconItemState(
    val title: String? = null,
    val iconRes: String? = null,
    val iconPlaceholder: Painter? = null,
    val tintColor: Color? = null,
    val borderWidth: Dp? = null,
    val borderColor: Color? = null,
    val backgroundColor: Color? = null,
    val selectedTintColor: Color? = null,
    val animateIcon: Boolean = false,
    val isSelected: Boolean = false,
    val innerPaddings: PaddingValues = PaddingValues(),
    val gap: Dp = 0.dp,
    val onAction: () -> Unit = {},
)
